export enum POP_UP_LOGIN_TYPE {
  SUGGESTED = 'suggested',
  ON_CLICK = 'onClick',
}

export interface LoginInterface {
  email: string;
  password: string;
}

export interface RegistrationInterface {
  email: string;
  password: string;
  submitPassword: string;
}

export interface PopUpLoginInterface {
  type: POP_UP_LOGIN_TYPE;
  error: boolean;
  onSubmit: (steps: number) => void;
  onClose: () => void;
  onNoAccount: () => void;
}

export interface PopUpRegistrationInterface {
  error: boolean;
  onSubmit: (steps: number) => void;
  onClose: () => void;
  toLogin: () => void;
}

export interface PopUpDeleteInterface {
  onAccept: () => void;
  onCancel: () => void;
  onClose: () => void;
}
